import React from 'react';
import { hydrate, render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router'
import store, { persistor, history } from './store';
import { PersistGate } from 'redux-persist/lib/integration/react';

import './i18n';
import './index.css';
import App from 'containers/App';
import reportWebVitals from './reportWebVitals';


const rootElement  = document.getElementById('root')

const LoadingView = () => (
  <div>Loading</div>
)

if (rootElement.hasChildNodes()) {
  hydrate(
    <Provider store={store}>
      <PersistGate loading={<LoadingView />} persistor={persistor}>
        <ConnectedRouter history={history}>
          <div>
            <App />
          </div>
        </ConnectedRouter>
      </PersistGate>
    </Provider>,
    rootElement 
  );
} else {
  render(
    <Provider store={store}>
      <PersistGate loading={<LoadingView />} persistor={persistor}>
        <ConnectedRouter history={history}>
          <div>
            <App />
          </div>
        </ConnectedRouter>
      </PersistGate>
    </Provider>,
    rootElement 
  );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
